import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT


export const listBar = (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbar/list', qs.stringify(params))
}

export const getQRCode = (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbar/detail', qs.stringify(params))
}
export const updateouttime= (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbar/updateouttime', qs.stringify(params))
}
export const checkBars= (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbar/checkBars', qs.stringify(params))
}
export const copyBars= (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbar/copyBars', qs.stringify(params))
}
export const batchCreate= (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbar/batchCreate', qs.stringify(params))
}
export const batchSave = (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbar/batchSave', qs.stringify(params))
}
export const batchSave2 = (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbar/batchSave2', qs.stringify(params))
}
export const updateStarttime = (params) => {
  return axios.post(root + '/warehouse/jxcstoregoodsbar/updateStarttime', qs.stringify(params))
}
export const printBar = (erpserial,start,colname,isnew,isbarcode,date) => {
  if (!start) start = 0;
  if (!colname) colname = ''
  return window.open(root + '/api/pdf/' + (isbarcode ? 'barcodePrint' : 'goodsbarPrint') + '?erpserial=' + erpserial + '&start=' + start + "&tenantid=" + JSON.parse(localStorage.getItem("hpapi_userInfoModel")).tenantid + "&colname=" + colname + (isnew ? ('&isnew=' + isnew) : '') + (date ? ('&date=' + date) : ''));
}



// WEBPACK FOOTER //
// ./src/api/set/jxcstoregoodsbar.js